<template lang="pug">
packages-listing
</template>

<script>
import PackagesListing from '@/components/hq/inventory/packages/PackagesListing.vue'

export default {
  name: 'InventoryPackages',
  components: { PackagesListing }
}
</script>
